module.exports = __webpack_public_path__ + "img/right_5.1429997d.jpg";